import { render } from "./NsiTable.vue?vue&type=template&id=47c8747a&scoped=true"
import script from "./NsiTable.vue?vue&type=script&lang=js"
export * from "./NsiTable.vue?vue&type=script&lang=js"

import "./NsiTable.vue?vue&type=style&index=0&id=47c8747a&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c8747a"]])

export default __exports__